import React from 'react'
import { HeaderV2Props } from './HeaderV2.routing'
import { StyledHeader } from './HeaderV2.styled'

export const HeaderV2: React.FC<HeaderV2Props> = (props: HeaderV2Props) => {
    const {
        sectionHeader,
        textCenter,
        specificHeaderSize,
        specificFontSize,
        borderWidth,
        hasBackground,
        displaySeeAll,
    } = props

    const StyledHeaderV2 = StyledHeader(specificHeaderSize || 'h2')

    return (
        <StyledHeaderV2
            textCenter={textCenter}
            specificFontSize={specificFontSize}
            hasBackground={hasBackground}
            borderWidth={borderWidth}
        >
            {sectionHeader?.heading}
        </StyledHeaderV2>
    )
}

HeaderV2.displayName = 'HeaderV2'
